<nz-divider [nzText]="originCountryAddress" nzOrientation="center">
  <ng-template #originCountryAddress>
    <h5>{{ 'PERSONAL_DATA_FORM.ORIGIN_COUNTRY_ADDRESS' | translate }}</h5>
  </ng-template>
</nz-divider>

<div class="row">
  <div class="nowrap-container">
    @for (field of firstRowMainFields; track field.key) {
      @if (controls[field.key]; as fieldControl) {
        <div
          class="standard-form-field {{ field.cssClass }} required-field"
          [class.widened-field]="field.key === 'originCountryAddressStreet'">
          <label [for]="field.inputId" [class.invalid]="fieldControl.touched && fieldControl.invalid">
            {{ 'PERSONAL_DATA_FORM.' + field.labelKey + '.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [id]="field.inputId"
              type="text"
              maxLength="100"
              [placeholder]="'PERSONAL_DATA_FORM.' + field.labelKey + '.PLACEHOLDER' | translate"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="fieldControl.touched && fieldControl.invalid ? 'true' : null"
              [attr.aria-describedby]="
                fieldControl.touched && fieldControl.invalid
                  ? field.errorId + ' ' + field.inputId + 'Tooltip'
                  : field.inputId + 'Tooltip'
              "
              [formControl]="fieldControl" />
            <app-cr-form-field-tooltip
              [id]="field.inputId + 'Tooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>
            @if (fieldControl.touched && fieldControl.invalid) {
              <mat-error [id]="field.errorId">
                {{ fieldControl.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    }
  </div>
  <div class="nowrap-container">
    @for (field of firstRowSideFields; track field.key) {
      @if (controls[field.key]; as fieldControl) {
        <div class="standard-form-field {{ field.cssClass }}">
          <label [for]="field.inputId" [class.invalid]="fieldControl.touched && fieldControl.invalid">
            {{ 'PERSONAL_DATA_FORM.' + field.labelKey + '.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [id]="field.inputId"
              type="text"
              maxLength="100"
              [placeholder]="'PERSONAL_DATA_FORM.' + field.labelKey + '.PLACEHOLDER' | translate"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="fieldControl.touched && fieldControl.invalid ? 'true' : null"
              [attr.aria-describedby]="
                fieldControl.touched && fieldControl.invalid
                  ? field.errorId + ' ' + field.inputId + 'Tooltip'
                  : field.inputId + 'Tooltip'
              "
              [formControl]="fieldControl" />
            <app-cr-form-field-tooltip
              [id]="field.inputId + 'Tooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>
            @if (fieldControl.touched && fieldControl.invalid) {
              <mat-error [id]="field.errorId">
                {{ fieldControl.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    }
  </div>
</div>

<div class="row extra-margin">
  @if (controls.originCountryAddressCountry; as originCountryAddressCountry) {
    <div class="nowrap-container">
      <div class="standard-form-field widened-field originCountryAddressCountry-field required-field">
        <app-country-select
          class="country-select"
          [fieldControl]="originCountryAddressCountry"
          [fieldKey]="'originCountryAddressCountry'"
          [isRequired]="true"
          [fieldLabelKey]="'ORIGIN-COUNTRY-ADDRESS-COUNTRY'">
        </app-country-select>
      </div>
    </div>
  }
  <div class="nowrap-container">
    @for (field of secondRowTextFields; track field.key) {
      @if (controls[field.key]; as fieldControl) {
        <div class="standard-form-field {{ field.cssClass }} required-field">
          <label [for]="field.inputId" [class.invalid]="fieldControl.touched && fieldControl.invalid">
            {{ 'PERSONAL_DATA_FORM.' + field.labelKey + '.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [id]="field.inputId"
              type="text"
              maxLength="100"
              [placeholder]="'PERSONAL_DATA_FORM.' + field.labelKey + '.PLACEHOLDER' | translate"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="fieldControl.touched && fieldControl.invalid ? 'true' : null"
              [attr.aria-describedby]="
                fieldControl.touched && fieldControl.invalid
                  ? field.errorId + ' ' + field.inputId + 'Tooltip'
                  : field.inputId + 'Tooltip'
              "
              [formControl]="fieldControl" />
            <app-cr-form-field-tooltip
              [id]="field.inputId + 'Tooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>
            @if (fieldControl.touched && fieldControl.invalid) {
              <mat-error [id]="field.errorId">
                {{ fieldControl.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    }
  </div>
</div>
